import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { AbstractRule } from './abstract-rule';
import { ValidationService } from '../validation.service';

export class ConditionalRequiredRule extends AbstractRule {
  property: string;
  value: string;
  type: string; // "skip" or "require"

  constructor(validationService: ValidationService) {
    super(validationService);
  }

  validate(c: AbstractControl): ValidationErrors | null {
    if (this.type === 'skip' && this.conditionMet(c)) {
      return null;
    }

    if (this.type === 'require' && !this.conditionMet(c)) {
      return null;
    }

    if (
      !c.value ||
      (typeof c.value === 'string' && c.value.trim() === '') ||
      (Array.isArray(c.value) && c.value.length === 0)
    ) {
      return { required: true };
    }

    return null;
  }

  private conditionMet(c: AbstractControl): boolean {
    if (!this.property || !this.value) {
      return false;
    }

    // Navigate up to the root form to access other controls
    let root = c;
    while (root.parent) {
      root = root.parent;
    }

    // Use controls property to access sibling controls
    const targetControl = (root as FormGroup).controls?.[this.property];
    if (targetControl) {
      return targetControl.value === this.value;
    }

    return false;
  }
}
